import React from 'react';
import { Modal, ListGroup } from 'react-bootstrap';
import { useWarehouse, getWarehouseAbbreviation } from '../contexts/WarehouseContext';

function WarehouseSelectorModal({ suppress = false }) {
    const { currentWarehouse, warehouses, loading, setCurrentWarehouse } = useWarehouse();

    // Show modal only when loading is complete, no warehouse is selected, and warehouses are available
    const show = !loading && !currentWarehouse && warehouses.length > 0 && !suppress;

    const handleSelectWarehouse = (warehouse) => {
        setCurrentWarehouse(warehouse);
    };

    return (
        <Modal show={show} backdrop="static" keyboard={false} centered>
            <Modal.Header>
                <Modal.Title>Select Your Warehouse</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="text-muted mb-3">
                    Please select the warehouse you are currently working at.
                    You can change this later from the header menu.
                </p>
                <ListGroup>
                    {warehouses.map((warehouse) => (
                        <ListGroup.Item
                            key={warehouse._id || warehouse.id}
                            action
                            onClick={() => handleSelectWarehouse(warehouse)}
                            className="d-flex align-items-center"
                        >
                            <span className="badge bg-primary me-3">
                                {getWarehouseAbbreviation(warehouse.name)}
                            </span>
                            <span>{warehouse.name}</span>
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            </Modal.Body>
        </Modal>
    );
}

export default WarehouseSelectorModal;
